import { render, staticRenderFns } from "./ReauthorizationPage.vue?vue&type=template&id=47f203de&scoped=true&"
import script from "./ReauthorizationPage.vue?vue&type=script&lang=js&"
export * from "./ReauthorizationPage.vue?vue&type=script&lang=js&"
import style0 from "./ReauthorizationPage.vue?vue&type=style&index=0&id=47f203de&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "47f203de",
  null
  
)

export default component.exports